import { render, staticRenderFns } from "./DangJi.vue?vue&type=template&id=08ba9789&scoped=true&"
import script from "./DangJi.vue?vue&type=script&lang=js&"
export * from "./DangJi.vue?vue&type=script&lang=js&"
import style0 from "./DangJi.vue?vue&type=style&index=0&id=08ba9789&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba9789",
  null
  
)

export default component.exports